export default __webpack_public_path__ + "static/media/icn-staff.7a1f66d4.svg";